    /**
     * Initialize Swiper(s)
     */
    function initSwiper() {
        if (typeof Swiper !== 'undefined') {
            new Swiper('.swiper__our-approach', {
                slidesPerView: 2,
                spaceBetween: 50,
                speed: 800,
                easing: 'ease-in-out',
                smoothScrolling: true,
                grabCursor: true,
                navigation: {
                    nextEl: '.our-approach__swiper-navigation .arrow-button__next',
                    prevEl: '.our-approach__swiper-navigation .arrow-button__prev',
                },
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 50,
                    }
                }
            });

            // Process carousel (vertical, no controls)
            new Swiper('.process-carousel', {
                direction: 'vertical',
                slidesPerView: 1.4,
                spaceBetween: 16,
                speed: 800,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                loop: true,
                easing: 'ease-in-out',
                allowTouchMove: true,
                mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges: true,
                    sensitivity: 0.8,
                },
            });
        }
    }

     /**
     * Initialize Gallery Swiper(s)
     */
    function initSwiperGallery() {
        if (typeof Swiper !== 'undefined') {
			// Gallery with thumbnails (multiple instances)
			const galleries = document.querySelectorAll('.gallery-with-thumbnails');

			galleries.forEach(gallery => {
				const mainEl = gallery.querySelector('.gallery-main');
				const thumbsEl = gallery.querySelector('.gallery-thumbs');
				if (!mainEl || !thumbsEl) return;

				// Thumbnails swiper (responsive: 3 on mobile, 5 on larger screens)
				const thumbsSwiper = new Swiper(thumbsEl, {
					slidesPerView: 3,
					spaceBetween: 10,
					speed: 600,
					easing: 'ease-in-out',
					allowTouchMove: true,
					watchSlidesProgress: true,
					slideToClickedSlide: true,
					freeMode: true,
					loop: true,
					breakpoints: {
						768: {
							slidesPerView: 5
						}
					}
				});

				// Main swiper linked to thumbnails
				const mainSwiper = new Swiper(mainEl, {
                    slidesPerView: 1,
                    spaceBetween: 10,
					speed: 600,
                    easing: 'ease-in-out',
                    allowTouchMove: true,
					effect: 'fade',
					fadeEffect: {
						crossFade: true
					},
					thumbs: { swiper: thumbsSwiper, autoScrollOffset: 1 },
					loop: true,
				});

				// Ensure the thumbnail track scrolls to reveal the active slide
				mainSwiper.on('slideChange', () => {
					const active = mainSwiper.realIndex;
					const visible = Number(thumbsSwiper.params.slidesPerView) || 4;
					const start = thumbsSwiper.activeIndex;
					const end = start + visible - 1;

					if (active > end) {
						thumbsSwiper.slideTo(active - visible + 1);
					} else if (active < start) {
						thumbsSwiper.slideTo(active);
					}
				});

			});
        }
    }
